module.exports = __webpack_public_path__ + "static/media/screenshot-8.2815356b.png";